import React from 'react';

export default function FreemiumSessionHelp() {
    return (
        <div className="center-horizontally">
            <div>
                <h3>We could not start your free review</h3>
                <p>The link may have expired or already been used, or the service may be temporarily unavailable.</p>
                <p>
                    <a href="https://www.legly.io/try-for-free">Start Try for Free again</a>{' '}
                    or <a href="/login">log in with your account</a>.
                </p>
            </div>
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/components/FreemiumSessionHelp.js